import styled from "styled-components";

export const Conten = styled.div`
  margin: 0;

  .modal-header {
    height: 84px;
    padding: 27px 49px;
    background-color: #94E8E8;
    border-radius: 24px 24px 0 0;

    span {
      padding: 0;
      margin: 0;
      font-size: 28px;
      font-weight: 700;
    }
  }

  .modal-body {
    margin-top: 50px;
    padding: 0 76px;
    text-align: center;
  }

  .modal-footer {
    border-radius: 0 0 24px 24px;
    border-top: 0;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
    margin-bottom: 49px;
  }
`;

export const ButtonBack = styled.button`
  height: 45px;
  background-color: #43474a;
  padding: 0 32px;

  color: #fafafa;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.9px;
  border: 0;
  border-radius: 145px;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);
`;

export const ButtonConfirm = styled.button`
  height: 45px;
  background-color: #FF1783;
  padding: 0 32px;

  color: #fafafa;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.9px;
  border: 0;
  border-radius: 145px;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);
`;
